import { TooltipWrapper } from "@app/shared";
import { wafflesKeyColumnName } from "@app/shared/waffles";
import InspectionProfileTableData from "./inspectionProfileTableData";
import { valueOrDashes } from "./utils";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

// have to disable sort-keys here until we can change how the table data is generated on the panel.

/* eslint-disable sort-keys */
export const generateAdditionalKnownSpecialtyProviderPanelRows = (rowKey: string, title: string, additionalSpecialties: string[], tooltipText = "Based on NPI"): InspectionProfileTableData => {
  return {
    [wafflesKeyColumnName]: rowKey,
    title: (
      <TooltipWrapper text={tooltipText} position="bottom">
        {title}
      </TooltipWrapper>
    ),
    source: generateRowSource(additionalSpecialties),
    result: generateRowResults(),
    reference: <>{"---"}</>
  };
}

const generateRowSource = (additionalSpecialties: string[]) => {
  return (additionalSpecialties && additionalSpecialties.length > 0) ?
    (additionalSpecialties.map((additionalKnownSpecialty, index) => {
      return (
        <div key={index}>
          <div>
            {valueOrDashes(additionalKnownSpecialty)}
          </div>
        </div>
      );
    })) :
    valueOrDashes(null)
}

const generateRowResults = () => {
  return (
    <span className="text-muted">
      <QesIcon iconName={QesIcons.FontAwesome.Question} width="8" description="the accuracy of this information is unknown" classNames="mx-2" />
    </span>
  );
}
